export const version = "logger/5.7.0";
//# sourceMappingURL=_version.js.map